import React from 'react';

import { Popover, MenuList } from '@mui/material';

import {
  StyledMenuItem,
  SearchContainer,
  StyledSearchIcon,
  StyledTextInput,
  Separator,
  DropdownContainer,
  StyledCircularProgress,
  ListContent,
} from './styles';

import { SearchPopoverProps } from './types';

const SearchPopover: React.FunctionComponent<SearchPopoverProps> = ({
  anchorEl,
  handleClose,
  handleUpdate,
  listData,
  search,
  ListItem,
  ListHeader,
  loading,
  customMargin,
  anchorOrigin,
  transformOrigin,
  id,
}) => (
  <Popover
    id={id}
    open={Boolean(anchorEl)}
    anchorEl={anchorEl}
    onClose={handleClose}
    anchorOrigin={
      anchorOrigin || {
        vertical: 'bottom',
        horizontal: 'right',
      }
    }
    transformOrigin={
      transformOrigin || {
        vertical: 'top',
        horizontal: 'center',
      }
    }
    onClick={(event: React.SyntheticEvent) => event.stopPropagation()}
  >
    <DropdownContainer>
      {search ? (
        <>
          <SearchContainer>
            <StyledSearchIcon />
            {/* override enter to no put empty lines */}
            <StyledTextInput {...search} autoFocus onEnter={() => false} />
          </SearchContainer>
          <Separator />
        </>
      ) : null}
      {loading ? (
        <StyledCircularProgress size="4em" />
      ) : (
        <MenuList>
          {ListHeader && <ListHeader />}

          <ListContent customMargin={customMargin}>
            {listData.map((item) =>
              ListItem ? (
                <ListItem key={item.uuid} item={item} onClick={() => handleUpdate(item)} />
              ) : (
                <StyledMenuItem key={item.uuid} onClick={() => handleUpdate(item)}>
                  {item.name}
                </StyledMenuItem>
              )
            )}
          </ListContent>
        </MenuList>
      )}
    </DropdownContainer>
  </Popover>
);

export default SearchPopover;
